import loadable from '@loadable/component';

export const OrgDashboardPostAListingPageContainerLoadable = loadable(
  () => import('./OrgDashboardPostAListingPageContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardPostAListingPageContainer,
  },
);
